import React from 'react';
import { currencyFormat } from 'utilities/common';

const Table = ({ data }) => {
  if (!data || data?.journals === null) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Neraca not found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive px-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-center border-end"
              style={{ whiteSpace: 'initial', width: '7%' }}
            >
              Akun
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '20%' }}
            >
              Nama Akun
            </th>
            <th
              className="text-center"
              style={{ whiteSpace: 'initial', width: '15%' }}
            >
              Jumlah
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '10%' }}
            >
            </th>
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.map((d, i) => (
            <tr key={i} className={`border-bottom ${d?.type === 'last' || d?.type === 'last_1' ? 'bg-light': ''}`}>
              {d?.type === 'last' && (
                <>
                  <td style={{width: '27%'}} colSpan={2}>
                    <div className="table-col">
                      <div className="text-ellipsis fw-semibold">
                        {d?.name}
                      </div>
                    </div>
                  </td>
                  <td style={{width: '15%'}}>
                    <div className="table-col text-end">
                      <div className="text-ellipsis fw-semibold text-uppercase">
                        {d?.nominal ? currencyFormat(d?.nominal) : '-'}
                      </div>
                    </div>
                  </td>
                  <td className="border-end" style={{width: '10%'}}/>
                </>
              )}

              {d?.type === 'last_1' && (
                <>
                  <td style={{width: '27%'}} colSpan={3}>
                    <div className="table-col">
                      <div className="text-ellipsis fw-semibold">
                        {d?.name}
                      </div>
                    </div>
                  </td>
                  <td className="border-end" style={{width: '10%'}}>
                    <div className="table-col text-end">
                      <div className="text-ellipsis fw-semibold text-uppercase">
                        {d?.nominal ? currencyFormat(d?.nominal) : '-'}
                      </div>
                    </div>
                  </td>
                </>
              )}

              {(d?.type === 'master' || d?.type === 'child') && (
                <>
                  <td className="border-end" style={{width: '7%'}}>
                    <div className="table-col text-center">
                      <div className="text-ellipsis">
                        {d?.code}
                      </div>
                    </div>
                  </td>
                  <td className="border-end" style={{width: '20%'}}>
                    <div className="table-col">
                      <div className="text-ellipsis text-uppercase">
                        {d?.name}
                      </div>
                    </div>
                  </td>
                  <td style={{width: '15%'}}>
                    <div className="table-col text-end">
                      <div className="text-ellipsis fw-semibold text-uppercase">
                        {d?.nominal ? currencyFormat(d?.nominal) : '-'}
                      </div>
                    </div>
                  </td>
                  <td className="border-end" style={{width: '10%'}}/>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
